<template>
  <div>
    <wc-section-title title='Accounting' subtitle='Reports'>
       <template v-slot:rightSide>
        <invoice-lookup-menu></invoice-lookup-menu>
      </template>
    </wc-section-title>
    <router-view></router-view>
  </div>
</template>

<script>
import InvoiceLookupMenu from '../../components/InvoiceLookupMenu';

export default {
  name: 'accounting-reports-base',
  components: {
    'invoice-lookup-menu': InvoiceLookupMenu
  }
}
</script>
